import FormLayout from '../../../layout/FormLayout/FormLayout';
import FormWrapper from '../../../layout/FormWrapper/FormWrapper';
import Input from '../../../../../components/Input/Input';
import Select from '../../../../../components/Select/Select';
import { StorageType } from '../../../StorageForm/StorageForm';
import styles from '../../../StorageForm/styles.module.css';
import { useState } from 'react';
import NotesCreateForm from '../../../StorageForm/components/forms/components/NotesCreateForm';

const StorageOtherPartTwo = ({ selectedData, onClose, handleNextStep }: any) => {
    const [notesVisible, setNotesVisible] = useState<boolean>(false);

    const toggleNotes = (visible: boolean) => {
        if (!selectedData.notes) return;
        setNotesVisible(visible);
    };

    return (
        <FormWrapper mode={'view'}>
            <FormLayout
                title={'Other items (2/2)'}
                description={'Other information about this structure needed for regulatory and compliance tracking.'}
                onClose={onClose}
                handlePrevStep={() => {
                    handleNextStep(StorageType.Other);
                }}
            >
                <h5 className={styles.formSemiHeader}>C. regulations, Laws, files</h5>

                <Select
                    value={selectedData.laws?.map((item: any) => ({
                        label: item.laws,
                        value: item.laws,
                    }))}
                    options={selectedData.laws}
                    valueKey={'laws'}
                    labelKey={'laws'}
                    isMulti={true}
                    placeholder={'No laws selected'}
                    readOnly={true}
                    disabled={!selectedData.doubleTreaties?.length}
                    info={'List of laws and regulations relevant to this vehicle, its investors and assets.'}
                >
                    Relevant laws And regulations
                </Select>

                <Input
                    value={selectedData.notes}
                    readOnly={true}
                    info={'Comments or notes relevant for this structure.'}
                    onClick={() => {
                        toggleNotes(true);
                    }}
                    style={'textPreview'}
                    type={'textarea'}
                    placeholder={'Your comments and notes'}
                >
                    Notes
                </Input>

                <Input
                    value={'No files stored'}
                    disabled={true}
                    info={'Stored files and documents relevant for this structure.'}
                >
                    Files
                </Input>
            </FormLayout>

            {notesVisible && (
                <NotesCreateForm
                    selectedData={selectedData.notes}
                    disabled={true}
                    onClose={() => {
                        toggleNotes(false);
                    }}
                />
            )}
        </FormWrapper>
    );
};

export default StorageOtherPartTwo;
